import React, { useEffect, useState, useRef } from 'react'
import { Card, Input, Tag, Select, Button, Avatar,Modal,Image, Spin } from 'antd'
import { connect } from 'react-redux'
import capitalize from 'lodash/capitalize'
import {
  SendOutlined,
  ArrowLeftOutlined,
  InfoCircleOutlined,
  EditOutlined,
  AlertOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons'
import '../css/admin.lite.scss'
import {
  addComment,
  updateLastViewed,
  getMessageCase,
  getPatientMessages,
  setPatientAndMsg,
  getImageUrl,
  setSingleMsg
} from '../../store/action/actioncases.action'
import moment from 'moment'
import util from '../../util/util'
import { isEmpty, isPlainObject, reverse } from 'lodash'
import ExpandableText from './expandable.text'
import { constants } from '../../constants'
import { useHistory, Redirect } from 'react-router-dom'
import PatientInfo from './patient.drawer'
import ZoomableImage from '../../component/zoom/zoom.image'
import _ from 'lodash'

const { Option } = Select
const { TextArea } = Input;
const MSGLENGTH = 4000

const MessageInterface = (props) => {
    const [open, setOpen] = useState(false)
    var history = useHistory()
  const messagesEndRef = useRef(null)
  const [priority, setPriority] = useState(false)
  const [input, setInput] = useState('')
  const [teams, setTeams] = useState([])
  const [imageUrl,setImageUrl]=useState([])
  const [imageopen,setImageOpen]=useState(false) 
  const userName = props.user?.firstname + ' ' + (props.user?.lastname || '')
console.log(props.singleMsg,"singleMsg")
  useEffect(() => {
    ;(async () => {
      if (props.singleMsg?.message?.caseId) {
        handleCareTeam()
        await props.updateLastViewed({
          caseId: props.singleMsg?.message?.caseId,
        })
        const newMsgList = await handleFetchMessages()
        const singleMsg = newMsgList.find(
          (m) => m?.patient?._id == props.singleMsg?.patient?._id
        )
        props.setPatientAndMsg(singleMsg)
        console.log(singleMsg, 'singleMsgg',props.singleMsgg)
      }
    })()
  }, [])

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [props.singleMsg?.message?.comments])

  const handleFetchMessages = async () => {
    try {
      const filter = {
        customerIds: props?.customer?._id
          ? [props.customer._id]
          : [props?.decoded?.customer],
      }

      if (props.user?.role === constants.ROLE.SURGEON || props.user?.surgeon) {
        filter.surgeonId = props.user?.surgeon
      }

      const data = await props.getPatientMessages({
        filters: filter,
        sorter: { field: 'lastUpdated', order: 'descend' },
      })

      return data
    } catch (err) {
      console.log(err, 'Error')
    }
  }
  const handleCareTeam = () => {
    const normalize = (name) => name?.replace(/\./g, '').trim().toLowerCase()
    const teams = [
      ...new Set(
        props.singleMsg?.message?.comments
          ?.filter(
            (e) =>
              e.userid !== props.singleMsg?.patient?._id &&
              normalize(e.userName) !==
                normalize(props.singleMsg?.patient?.surgeon?.name)
          )
          .map((e) => e.userName)
      ),
    ]
    

    setTeams(teams)
  }
  const handleSendMessage = async () => {
    try {
      if (!input || input.trim() == '') return

      const commentObject = await props.addComment({
        caseId: props.singleMsg?.message?.caseId,
        comment: input,
        priority,
      })
      if (commentObject.status) {
        setInput('')
        // await props.handleFetchMessages()
        const singleMsg = await props.getMessageCase(
          props.singleMsg?.message?.caseId
        )
        // props.handleSingleMsg(singleMsg)
        props.setSingleMsg({...props.singleMsg, message: singleMsg})
      }
    } catch (error) {
      console.log(error)
    }
  }
  const showSubject = () => {
    const msg = props.singleMsg?.message
    return (
      <div className={`message lite-subject`}>
        {
          <div className=''>
           {msg?.summary }
          </div>
        }
        {/* <div className='bubble'>{msg?.summary }</div> */}
      
      </div>
    )
  }
  const renderImageUrls=(imageUrl)=>{
    if(_.isEmpty(imageUrl) || _.isEmpty(imageUrl.thumbnail) )return;
    return(
      <div className= {`coversation-img`}>{
       <img 
        onClick={(e)=>viewImage(imageUrl.original)}
        src = {imageUrl.thumbnail} 
        alt={`img`}
      />
      }</div>
    )
  }  
  const showDescription = () => {
    const msg = props.singleMsg?.message
    return (
      <div className={`message ${getBubbleClass(msg?.reportedBy)}`}>
        {
          <div className='sender'>
            {msg?.reportedUsername ? msg.reportedUsername : showName()}
          </div>
        }
        <div className='bubble'>
          {msg?.description || msg?.caseDescription}
           {renderImageUrls(msg.imageUrl)}  
        </div>
        <div className='timestamp'>
          {moment(msg?.createdDate).format(constants.DATE_FORMAT.FORMAT2)}
        </div>
     
      </div>
    )
  }

  const showName = () =>
    capitalize(props.singleMsg?.patient?.firstname) +
    ' ' +
    capitalize(props.singleMsg?.patient?.lastname)
  const getBubbleClass = (id, userName) => {
    if (!props.user?.surgeon) {
      if (id == props.user?._id) return 'admin right'
      else if (teams.includes(userName)) return 'admin'
      else if (id != props.singleMsg?.patient?._id) return 'current'
      return 'other'
    }
    if (id == props.user?._id) return 'current right'
    if (id != props.singleMsg?.patient?._id) return 'admin'
    return 'other'
  }
      const handleNavigate=async(path,pathName)=>{
        await history.push({ pathname:pathName, search: constants.ADMIN_LITE })
          await window.ReactNativeWebView.postMessage(
          JSON.stringify({
            route: '/navigate',
            data: { path },
          })
        )
       
      }
  const handleBack = () => {
    if (props.patientAndMsg?.messages.length > 1){
            const path = `/patient-message${constants.ADMIN_LITE}`
            const pathName= '/patient-message'
            handleNavigate(path,pathName)
    } 
    else {
      const path = `/messages${constants.ADMIN_LITE}`
      const pathName= '/messages'
      handleNavigate(path,pathName)
      props.setPatientAndMsg({})
    }
  }
  const handleDrawer = (isOpen = false) => {
    setOpen(isOpen)
  }
    const viewImage = async(fileName)=>{
      try{
         const res= await props.getImageUrl({fileName,type:constants.AWS_FOLDER_NAME.MESSAGE});
        setImageUrl(res.imageUrl)
        setImageOpen(true)
      }
      catch(err){
        console.log(err,"Error in viewImage")
      }
    }
      const renderImageModal = () => (
        <ZoomableImage src={imageUrl} open={imageopen}  onClose={() => setImageOpen(false)}/>
      // <Image
      //   src={imageUrl}
      //   style={{ display: 'none' }} 
      //   preview={{
      //     visible: imageopen,
      //     onVisibleChange: (visible) => setImageOpen(visible),
      //     height:'80%',
      //   }}
      // />
    );

  return (
    <Spin spinning={props.isLoading}>
    <div className='admin-lite'>
    <div className='chat-container'>
    <div className='chat-layout'>
       {open && (
              <PatientInfo
                open={open}
                handleDrawer={handleDrawer}
                patient={props.patientAndMsg?.patient}
              />
            )}
      {/* Header */}
      <div className='chat-header'>
        <span className='arrow-left' onClick={handleBack}>
          <ArrowLeftOutlined style={{ fontSize: 22, cursor: 'pointer' }} />
        </span>
        <span className='chat-title'>{showName()}</span>
 <Button   className='patient-info-container'type='primary'  onClick={() => handleDrawer(true)}> Patient Info</Button>
        {/* <InfoCircleOutlined
          className='icon'
          onClick={() => handleDrawer(true)}
        /> */}
      </div>

      {/* Care Team */}
      <div className='care-team'>
        <span className='care-team-label'>Care Team: </span>
        <Tag color='blue'>
          {props.singleMsg?.patient?.surgeon?.name || 'NA'} (provider)
        </Tag>
        {teams.map((t, i) => (
          <Tag color='green' key={i}>
            {t || 'NA'} (admin)
          </Tag>
        ))}
      </div>

      {/* Messages */}
      <div className='messages'>
        {showSubject()}
        {showDescription()}
        {reverse([...(props.singleMsg?.message?.comments || [])]).map(
          (comment, idx) => (
            <div
              className={`message ${getBubbleClass(comment.userid, comment.userName)}`}
              key={idx}
            >
              {
                <div className='sender'>
                  {!comment.priority ? (
                    comment?.userName
                  ) : (
                    <>
                      {comment?.userName}
                      <ExclamationCircleOutlined
                        style={{ color: 'red', marginLeft: 5 }}
                      />
                    </>
                  )}
                </div>
              }
              <div className={`bubble ${(comment.comment=='NA' && !isEmpty(comment.imageUrl))?'imageUrl-div':''} `}>
                <ExpandableText comment={comment?.comment} imageUrl={comment.imageUrl} viewImage={viewImage}/>
                 {renderImageUrls(comment.imageUrl)}  
              </div>
              <div className='timestamp'>
                {moment(comment?.commented_date).format(
                  constants.DATE_FORMAT.FORMAT2
                )}
              </div>
            </div>
          )
        )}
        <div ref={messagesEndRef} />
      </div>

      {/* Footer */}
      <div className='chat-footer'>
        <Select
          value={priority}
          className='priority-select'
          onChange={(val) => setPriority(val)}
        >
          <Option value={false}>
            <EditOutlined /> Normal
          </Option>
          <Option value={true}>
            <AlertOutlined style={{ color: 'red' }} /> Urgent
          </Option>
        </Select>
        <span className='replying-as'>
          Replying as: {userName}{' '}
          {props.user?.surgeon ? '(Provider)' : '(Clinic Admin)'}
        </span>
      </div>

      <div className='chat-footer'>
        <TextArea
          className='message-input'
          placeholder='Type your message...'
          value={input}
          onChange={(e) => setInput(e.target.value)}
        />
        <Button
          type='primary'
          shape='circle'
          icon={<SendOutlined />}
          onClick={handleSendMessage}
        />
      </div>
    </div>
    </div>
    {renderImageModal()}
    </div>
    </Spin>
  )
}

const mapStateToProps = (state) => {
  return {
    patient: state.patient.patient,
    editCase: state.actioncase.editcase,
    singleMsg: state.actioncase.singleMsg,
    patientAndMsg: state.actioncase.patientAndMsg,
    isLoading: state.actioncase.isLoading,
    healthCoachList: state.actioncase.healthCoachList,
    token: util.verifyToken(state.profile.token),
    company: state.profile.company,
    patientLoading: state.patient.isLoading,
    customer: state.profile.customer,
    searchText: state.user.searchText,
    user: state.profile.user,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getPatientMessages: (params) => dispatch(getPatientMessages(params)),
    getMessageCase: (params) => dispatch(getMessageCase(params)),
    getImageUrl: (params) => dispatch(getImageUrl(params)),
    addComment: (data) => dispatch(addComment(data)),
    updateLastViewed: (caseId) => dispatch(updateLastViewed(caseId)),
    setPatientAndMsg: (params) => dispatch(setPatientAndMsg(params)),
    setSingleMsg: (params) => dispatch(setSingleMsg(params)),
  }
  
}

export default connect(mapStateToProps, mapDispatchToProps)(MessageInterface)
